import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { registerPmtilesProtocol } from './hooks/useOfflineMap.ts'
import { getCloudflareAnalytics } from './services/cloudflareAnalytics'
import './index.css'
import './i18n'
import App from './App.tsx'
import { ScheduleProvider } from './context/ScheduleContext.tsx'

registerPmtilesProtocol()

// Register SW only when built (dev has no sw.js; injectManifest builds it on vite build)
if (!import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' })
}

getCloudflareAnalytics().init()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ScheduleProvider>
        <App />
      </ScheduleProvider>
    </BrowserRouter>
  </StrictMode>,
)
